function ViewSelect(props) {
    function updateView(a, b, c, d, e, f) {
        props.setMain(a);
        props.setFx(b);
        props.setGlobal(c);
        props.setWtEditor(d);
        props.setMatrix(e);
        props.setPreset(f);
    }

    return (
        <div>
            <h2>Views</h2>
            <h3 onClick={() => updateView("block", "none", "none", "none", "none", "none")}>Main/OSC</h3>
            <h3 onClick={() => updateView("none", "block", "none", "none", "none", "none")}>FX Menu</h3>
            <h3 onClick={() => updateView("none", "none", "block", "none", "none", "none")}>Global</h3>
            <h3 onClick={() => updateView("none", "none", "none", "block", "none", "none")}>Wavetable Editor</h3>
            <h3 onClick={() => updateView("none", "none", "none", "none", "block", "none")}>Matrix</h3>
            <h3 onClick={() => updateView("none", "none", "none", "none", "none", "block")}>Preset Menu</h3>
        </div>
    )
}

export default ViewSelect;